/* Taptics · «Elige tus placas» (sections/tpx-placas.liquid).
   Google, Instagram y WiFi en la cantidad que se quiera; el descuento por cantidad
   (descuentos automáticos de Shopify, mínimo de unidades) cuenta todas las placas del carrito.
   - Google / Instagram: vinculación opcional con el iframe de app.taptics.eu/vincula
     (tipo google, instagram o pack si lleva las dos), con la cantidad para vincular placa a placa.
     El código va en cada línea (propiedad _taptics_vinculo) y, por compatibilidad, al atributo del carrito.
   - WiFi: datos obligatorios con el formulario de taptics-wifi.js; una línea del carrito por red. */
(function () {
  var box = document.getElementById('tpxb');
  var dataEl = document.getElementById('tpxb-data');
  if (!box || !dataEl) return;
  var D = JSON.parse(dataEl.textContent);
  var L = D.lang || 'es';
  var APP = 'https://app.taptics.eu';
  var TIERS = [[5, 35], [4, 30], [3, 25], [2, 20]];
  var FIX2 = 1999; // con 2 placas Shopify resta 19,99 € al total (no un %): el tramo «20» de TIERS solo lo identifica
  var MAXQ = 20;

  var T = {
    es: {
      plates: function (n) { return n === 1 ? '1 placa' : n + ' placas'; },
      ladder0: 'precio normal', save: function (p) { return '−' + p + ' %'; },
      next: function (k, d) { return 'Añade ' + (k === 1 ? '1 placa más' : k + ' placas más') + ' y ahorra ' + d + '.'; },
      max: 'Tienes el máximo descuento: −35 %.',
      start: 'Desde 2 placas, el descuento se aplica solo en el carrito.',
      inCart: function (n) { return 'Contamos también ' + (n === 1 ? 'la placa' : 'las ' + n + ' placas') + ' que ya tienes en el carrito.'; },
      google: { tag: 'Reseñas', h: 'Taptics Google', p: 'Tus clientes acercan el móvil o escanean el QR y te dejan la reseña en Google al momento.', need: '<b>Te pediremos:</b> tu negocio en Google. Ahora o al recibirla.' },
      instagram: { tag: 'Seguidores', h: 'Taptics Instagram', p: 'Acercan el móvil y se abre tu perfil de Instagram para seguirte.', need: '<b>Te pediremos:</b> tu usuario de Instagram. Ahora o al recibirla.' },
      wifi: { tag: 'WiFi', h: 'Taptics WiFi', p: 'Tus clientes escanean el QR y se conectan a tu WiFi sin pedir la contraseña.', need: '<b>Te pediremos:</b> el nombre y la contraseña de tu WiFi antes de comprar, porque van grabados en el QR.' },
      more: 'Ver detalles', add: 'Añadir', minus: 'Quitar una', plus: 'Añadir una', unavailable: 'No disponible',
      linkH: 'Google e Instagram: déjalas listas', linkOpt: 'Opcional', linkSub: 'Si eliges ahora tu negocio o tu Instagram, te llegan funcionando. Si lo prefieres, lo haces al recibirlas en un minuto.',
      linkMulti: 'Todas tus placas Google irán a este negocio. ¿Son para locales distintos? Déjalo en blanco y configura cada una desde tu panel al recibirlas.',
      linkDone: 'Listo', wifiH: 'WiFi: los datos de tu red', wifiReq: 'Obligatorio', wifiSub: 'Van grabados en el QR de la placa. Compruébalo escaneando el QR con tu móvil en tu local antes de comprar.',
      same: function (n) { return 'Las ' + n + ' placas WiFi son para la misma red'; }, wifiN: function (i) { return 'Placa WiFi ' + i; },
      total: 'Total', saving: function (x, d) { return 'Ahorras ' + x + (d ? ' (' + d + ')' : ''); }, onTotal: 'en el total', none: 'Aún no has elegido ninguna placa',
      withCart: function (c, d) { return d + ' contando ' + (c === 1 ? 'la de tu carrito' : 'las ' + c + ' de tu carrito'); },
      go: 'Añadir al carrito', pick: 'Elige una placa', adding: 'Añadiendo…',
      wifiFix: 'Completa los datos de tu WiFi y marca la casilla de comprobación.', fail: 'No se ha podido añadir al carrito. Vuelve a intentarlo.'
    },
    fr: {
      plates: function (n) { return n === 1 ? '1 plaque' : n + ' plaques'; },
      ladder0: 'prix normal', save: function (p) { return '−' + p + ' %'; },
      next: function (k, d) { return 'Ajoutez ' + (k === 1 ? '1 plaque de plus' : k + ' plaques de plus') + ' et économisez ' + d + '.'; },
      max: 'Vous avez la remise maximale : −35 %.',
      start: 'Dès 2 plaques, la remise s’applique toute seule dans le panier.',
      inCart: function (n) { return 'Nous comptons aussi ' + (n === 1 ? 'la plaque' : 'les ' + n + ' plaques') + ' déjà dans votre panier.'; },
      google: { tag: 'Avis', h: 'Taptics Google', p: 'Vos clients approchent leur téléphone ou scannent le QR code et laissent leur avis Google sur-le-champ.', need: '<b>Nous vous demanderons :</b> votre établissement sur Google. Maintenant ou à la réception.' },
      instagram: { tag: 'Abonnés', h: 'Taptics Instagram', p: 'Ils approchent leur téléphone et votre profil Instagram s’ouvre pour vous suivre.', need: '<b>Nous vous demanderons :</b> votre nom d’utilisateur Instagram. Maintenant ou à la réception.' },
      wifi: { tag: 'WiFi', h: 'Taptics WiFi', p: 'Vos clients scannent le QR code et se connectent à votre WiFi sans demander le mot de passe.', need: '<b>Nous vous demanderons :</b> le nom et le mot de passe de votre WiFi avant l’achat, car ils sont gravés dans le QR code.' },
      more: 'Voir les détails', add: 'Ajouter', minus: 'En retirer une', plus: 'En ajouter une', unavailable: 'Indisponible',
      linkH: 'Google et Instagram : prêtes à l’emploi', linkOpt: 'Facultatif', linkSub: 'Si vous choisissez maintenant votre établissement ou votre Instagram, elles arrivent prêtes. Sinon, vous le faites à la réception en une minute.',
      linkMulti: 'Toutes vos plaques Google iront vers cet établissement. Elles sont pour des établissements différents ? Laissez vide et configurez chacune depuis votre espace à la réception.',
      linkDone: 'Prêt', wifiH: 'WiFi : les informations de votre réseau', wifiReq: 'Obligatoire', wifiSub: 'Elles sont gravées dans le QR code de la plaque. Vérifiez en scannant le QR code avec votre téléphone dans votre établissement avant d’acheter.',
      same: function (n) { return 'Les ' + n + ' plaques WiFi sont pour le même réseau'; }, wifiN: function (i) { return 'Plaque WiFi ' + i; },
      total: 'Total', saving: function (x, d) { return 'Vous économisez ' + x + (d ? ' (' + d + ')' : ''); }, onTotal: 'sur le total', none: 'Vous n’avez encore choisi aucune plaque',
      withCart: function (c, d) { return d + ' en comptant ' + (c === 1 ? 'celle de votre panier' : 'les ' + c + ' de votre panier'); },
      go: 'Ajouter au panier', pick: 'Choisissez une plaque', adding: 'Ajout…',
      wifiFix: 'Complétez les informations WiFi et cochez la case de vérification.', fail: 'Impossible d’ajouter au panier. Réessayez.'
    },
    en: {
      plates: function (n) { return n === 1 ? '1 stand' : n + ' stands'; },
      ladder0: 'full price', save: function (p) { return '−' + p + '%'; },
      next: function (k, d) { return 'Add ' + (k === 1 ? '1 more stand' : k + ' more stands') + ' and save ' + d + '.'; },
      max: 'You have the maximum discount: −35%.',
      start: 'From 2 stands, the discount is applied automatically in the cart.',
      inCart: function (n) { return 'We also count ' + (n === 1 ? 'the stand' : 'the ' + n + ' stands') + ' already in your cart.'; },
      google: { tag: 'Reviews', h: 'Taptics Google', p: 'Your customers tap their phone or scan the QR code and leave a Google review on the spot.', need: '<b>We’ll ask for:</b> your business on Google. Now or when it arrives.' },
      instagram: { tag: 'Followers', h: 'Taptics Instagram', p: 'They tap their phone and your Instagram profile opens so they can follow you.', need: '<b>We’ll ask for:</b> your Instagram username. Now or when it arrives.' },
      wifi: { tag: 'WiFi', h: 'Taptics WiFi', p: 'Your customers scan the QR code and join your WiFi without asking for the password.', need: '<b>We’ll ask for:</b> your WiFi name and password before you buy, because they’re engraved in the QR code.' },
      more: 'See details', add: 'Add', minus: 'Remove one', plus: 'Add one', unavailable: 'Unavailable',
      linkH: 'Google and Instagram: ready to use', linkOpt: 'Optional', linkSub: 'Choose your business or your Instagram now and they arrive ready to use. Or do it in a minute when they arrive.',
      linkMulti: 'All your Google stands will go to this business. Are they for different locations? Leave it blank and set each one up from your dashboard when they arrive.',
      linkDone: 'Done', wifiH: 'WiFi: your network details', wifiReq: 'Required', wifiSub: 'They’re engraved in the stand’s QR code. Check it by scanning the QR code with your phone at your venue before you buy.',
      same: function (n) { return 'All ' + n + ' WiFi stands are for the same network'; }, wifiN: function (i) { return 'WiFi stand ' + i; },
      total: 'Total', saving: function (x, d) { return 'You save ' + x + (d ? ' (' + d + ')' : ''); }, onTotal: 'off the total', none: 'You haven’t chosen any stands yet',
      withCart: function (c, d) { return d + ' counting ' + (c === 1 ? 'the one' : 'the ' + c) + ' in your cart'; },
      go: 'Add to cart', pick: 'Choose a stand', adding: 'Adding…',
      wifiFix: 'Fill in your WiFi details and tick the confirmation box.', fail: 'Couldn’t add to cart. Please try again.'
    },
    de: {
      plates: function (n) { return n === 1 ? '1 Platte' : n + ' Platten'; },
      ladder0: 'Normalpreis', save: function (p) { return '−' + p + ' %'; },
      next: function (k, d) { return 'Nimm ' + (k === 1 ? '1 Platte' : k + ' Platten') + ' mehr und spare ' + d + '.'; },
      max: 'Du hast den höchsten Rabatt: −35 %.',
      start: 'Ab 2 Platten wird der Rabatt im Warenkorb automatisch abgezogen.',
      inCart: function (n) { return 'Wir zählen auch ' + (n === 1 ? 'die Platte' : 'die ' + n + ' Platten') + ' mit, die schon in deinem Warenkorb ' + (n === 1 ? 'ist' : 'sind') + '.'; },
      google: { tag: 'Bewertungen', h: 'Taptics Google', p: 'Deine Kunden halten das Handy dran oder scannen den QR-Code und bewerten dich sofort auf Google.', need: '<b>Wir fragen dich nach:</b> deinem Unternehmen auf Google. Jetzt oder nach Erhalt.' },
      instagram: { tag: 'Follower', h: 'Taptics Instagram', p: 'Sie halten das Handy dran und dein Instagram-Profil öffnet sich zum Folgen.', need: '<b>Wir fragen dich nach:</b> deinem Instagram-Namen. Jetzt oder nach Erhalt.' },
      wifi: { tag: 'WLAN', h: 'Taptics WiFi', p: 'Deine Kunden scannen den QR-Code und sind in deinem WLAN, ohne nach dem Passwort zu fragen.', need: '<b>Wir fragen dich nach:</b> WLAN-Name und Passwort vor dem Kauf, denn sie werden in den QR-Code graviert.' },
      more: 'Details ansehen', add: 'Hinzufügen', minus: 'Eine weniger', plus: 'Eine mehr', unavailable: 'Nicht verfügbar',
      linkH: 'Google und Instagram: startklar', linkOpt: 'Optional', linkSub: 'Wähle jetzt dein Unternehmen oder dein Instagram, dann kommen sie einsatzbereit an. Oder erledige es in einer Minute nach Erhalt.',
      linkMulti: 'Alle deine Google-Platten führen zu diesem Unternehmen. Sind sie für verschiedene Standorte? Lass das Feld leer und richte jede nach Erhalt in deinem Dashboard ein.',
      linkDone: 'Fertig', wifiH: 'WLAN: deine Netzdaten', wifiReq: 'Pflicht', wifiSub: 'Sie werden in den QR-Code der Platte graviert. Prüfe sie vor dem Kauf, indem du den QR-Code in deinem Lokal mit dem Handy scannst.',
      same: function (n) { return 'Alle ' + n + ' WLAN-Platten sind für dasselbe Netz'; }, wifiN: function (i) { return 'WLAN-Platte ' + i; },
      total: 'Gesamt', saving: function (x, d) { return 'Du sparst ' + x + (d ? ' (' + d + ')' : ''); }, onTotal: 'auf den Gesamtpreis', none: 'Du hast noch keine Platte gewählt',
      withCart: function (c, d) { return d + ' inkl. ' + (c === 1 ? 'der Platte' : 'der ' + c + ' Platten') + ' im Warenkorb'; },
      go: 'In den Warenkorb', pick: 'Wähle eine Platte', adding: 'Wird hinzugefügt…',
      wifiFix: 'Fülle deine WLAN-Daten aus und setze das Häkchen zur Bestätigung.', fail: 'Konnte nicht in den Warenkorb gelegt werden. Bitte versuch es noch einmal.'
    }
  };
  var t = T[L] || T.es;
  var COLORS = { google: '#F5B100', instagram: '#F04A52', wifi: '#00B8B0' };
  var fmt;
  try { fmt = new Intl.NumberFormat(D.locale || L, { style: 'currency', currency: D.currency || 'EUR' }); } catch (e) { fmt = { format: function (v) { return v.toFixed(2) + ' €'; } }; }
  // Mismo formato que el resto de la tienda (filtro money de Shopify), a partir de una muestra de 1234,56
  var mfmt = null;
  (function () {
    var m = /1([.,'\u00a0\u202f ]?)234([.,])56/.exec(D.moneySample || '');
    if (m) mfmt = { pre: D.moneySample.slice(0, m.index), post: D.moneySample.slice(m.index + m[0].length), th: m[1], dec: m[2] };
  })();
  function money(cents) {
    cents = Math.round(cents);
    if (!mfmt) return fmt.format(cents / 100);
    var i = String(Math.floor(cents / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, mfmt.th);
    return mfmt.pre + i + mfmt.dec + ('0' + (cents % 100)).slice(-2) + mfmt.post;
  }
  function el(tag, attrs, html) {
    var e = document.createElement(tag);
    for (var k in attrs || {}) e.setAttribute(k, attrs[k]);
    if (html != null) e.innerHTML = html;
    return e;
  }
  function pct(n) { for (var i = 0; i < TIERS.length; i++) if (n >= TIERS[i][0]) return TIERS[i][1]; return 0; }
  function tierTxt(p) { return '−' + (p === 20 ? money(FIX2) : p + (L === 'en' ? '%' : ' %')); }
  function saveTxt(p) { return p === 20 ? money(FIX2) : (L === 'es' ? 'un ' : '') + p + (L === 'en' ? '%' : ' %'); }

  var P = {}; D.products.forEach(function (p) { P[p.key] = p; });
  var qty = { google: 0, instagram: 0, wifi: 0 };
  var inCart = 0; // placas que ya están en el carrito y cuentan para el descuento
  var eligible = {}; D.products.forEach(function (p) { eligible[p.variant] = 1; }); if (D.logoVariant) eligible[D.logoVariant] = 1;
  var linkCode = '';

  // Escalera de descuentos
  var ladder = document.getElementById('tpxb-ladder');
  [1, 2, 3, 4, 5].forEach(function (n) {
    var s = el('div', { 'class': 'tpxb-step', 'data-n': n });
    s.appendChild(el('b', null, n === 5 ? '5+' : String(n)));
    s.appendChild(el('span', null, n === 1 ? t.ladder0 : tierTxt(pct(n))));
    ladder.appendChild(s);
  });

  // Tarjetas
  var cards = document.getElementById('tpxb-cards'), outs = {};
  var logoCard = document.getElementById('tpxb-logo'); // tarjeta de la placa con logo (Liquid), siempre la última
  ['google', 'instagram', 'wifi'].forEach(function (k) {
    var p = P[k]; if (!p) return;
    var c = el('article', { 'class': 'tpxb-card', 'data-k': k });
    var img = el('a', { 'class': 'tpxb-img', href: p.url, tabindex: '-1', 'aria-hidden': 'true' });
    if (p.image) img.appendChild(el('img', { src: p.image, alt: p.title, loading: 'lazy', width: '800', height: '600' }));
    var tag = el('span', { 'class': 'tpxb-tag' }); tag.textContent = t[k].tag; tag.style.background = COLORS[k];
    if (k === 'google') tag.style.color = '#17140F';
    img.appendChild(tag);
    c.appendChild(img);
    var b = el('div', { 'class': 'tpxb-body' });
    b.appendChild(el('h2', null, t[k].h));
    var pp = el('p'); pp.textContent = t[k].p + ' ';
    var more = el('a', { 'class': 'tpxb-more', href: p.url }); more.textContent = t.more; pp.appendChild(more);
    b.appendChild(pp);
    var need = el('p', { 'class': 'tpxb-need', hidden: '' }, t[k].need); b.appendChild(need);
    var buy = el('div', { 'class': 'tpxb-buy' });
    var pr = el('span', { 'class': 'tpxb-price' }, money(p.price)); buy.appendChild(pr);
    var q = el('div', { 'class': 'tpxb-qty' });
    var m = el('button', { type: 'button', 'aria-label': t.minus }, '−');
    var o = el('output', { 'aria-live': 'polite' }, '0');
    var pl = el('button', { type: 'button', 'aria-label': t.plus }, '+');
    m.onclick = function () { set(k, qty[k] - 1); };
    pl.onclick = function () { set(k, qty[k] + 1); };
    q.appendChild(m); q.appendChild(o); q.appendChild(pl);
    if (p.available) buy.appendChild(q); else buy.appendChild(el('span', null, t.unavailable));
    b.appendChild(buy);
    c.appendChild(b);
    cards.insertBefore(c, logoCard);
    outs[k] = { card: c, out: o, minus: m, plus: pl, need: need, price: pr };
  });

  // Panel de vinculación (Google / Instagram)
  var setup = document.getElementById('tpxb-setup');
  var pLink = document.getElementById('tpxb-p-link');
  var lh = el('h3', null, '<i style="background:' + COLORS.google + '"></i><i style="background:' + COLORS.instagram + ';margin-left:-14px"></i>' + t.linkH + ' <span class="tpxb-badge" id="tpxb-lb">' + t.linkOpt + '</span>');
  pLink.appendChild(lh);
  var lsub = el('p', { 'class': 'tpxb-sub' }); lsub.textContent = t.linkSub; pLink.appendChild(lsub);
  var lmulti = el('p', { 'class': 'tpxb-sub', hidden: '' }); lmulti.textContent = t.linkMulti; pLink.appendChild(lmulti);
  var frame = el('iframe', { title: 'Taptics', loading: 'lazy' });
  pLink.appendChild(frame);
  var linkType = '';
  function linkQty() { return Math.max(qty.google, qty.instagram, 1); }
  var sentQty = 0;
  function sendQty() { var n = linkQty(); if (n !== sentQty && frame.contentWindow && linkType) { sentQty = n; frame.contentWindow.postMessage({ t: 'taptics-qty', n: n }, APP); } }
  frame.addEventListener('load', function () { sentQty = 0; sendQty(); });
  function linkKind() { return qty.google && qty.instagram ? 'pack' : qty.google ? 'google' : qty.instagram ? 'instagram' : ''; }
  function loadFrame() {
    var k = linkKind();
    if (!k || k === linkType) { sendQty(); return; }
    linkType = k; sentQty = linkQty();
    frame.src = APP + '/vincula?embed=1&type=' + k + '&lang=' + encodeURIComponent(L) + '&qty=' + sentQty + '&code=' + encodeURIComponent(linkCode || '');
  }
  window.addEventListener('message', function (e) {
    var d = e.data;
    if (e.origin !== APP || !d || e.source !== frame.contentWindow) return;
    if (d.t === 'taptics-lh' && d.h > 40) frame.style.height = d.h + 'px';
    if (d.t === 'taptics-link' && /^[A-Z0-9]{8}$/.test(d.code || '')) {
      linkCode = d.code;
      var lb = document.getElementById('tpxb-lb'); if (lb) { lb.textContent = t.linkDone; lb.className = 'tpxb-badge ok'; }
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { taptics_vinculo: d.code } }) }).catch(function () {});
    }
  });

  // Panel WiFi
  var pWifi = document.getElementById('tpxb-p-wifi');
  pWifi.appendChild(el('h3', null, '<i style="background:' + COLORS.wifi + '"></i>' + t.wifiH + ' <span class="tpxb-badge req" id="tpxb-wb">' + t.wifiReq + '</span>'));
  var wsub = el('p', { 'class': 'tpxb-sub' }); wsub.textContent = t.wifiSub; pWifi.appendChild(wsub);
  var sameW = el('label', { 'class': 'tpxb-same', hidden: '' });
  var sameI = el('input', { type: 'checkbox' }); sameI.checked = true;
  var sameT = el('span'); sameW.appendChild(sameI); sameW.appendChild(sameT);
  pWifi.appendChild(sameW);
  var wForms = [], creating = false; // { wrap, label, form }
  function wifiForm(i) {
    creating = true;
    while (wForms.length <= i) {
      var n = wForms.length;
      var wrap = el('div', { 'class': 'tpxb-wifi-wrap' });
      var lab = el('p', { 'class': 'tpxb-wlabel' }); lab.textContent = t.wifiN(n + 1);
      var root = el('div', { 'class': 'tpxb-wifi' });
      wrap.appendChild(lab); wrap.appendChild(root); pWifi.appendChild(wrap);
      var w = { wrap: wrap, label: lab, root: root, form: null };
      wForms.push(w);
      w.form = window.TapticsWifiForm ? window.TapticsWifiForm.create(root, { lang: L, idp: 'tpxb' + n, onChange: function () { if (!creating) refresh(); } }) : null;
    }
    creating = false;
    return wForms[i];
  }
  function wifiCount() { return qty.wifi ? (sameI.checked ? 1 : qty.wifi) : 0; }
  function layoutWifi() {
    var n = wifiCount();
    sameW.hidden = qty.wifi < 2;
    sameT.textContent = t.same(qty.wifi);
    for (var i = 0; i < Math.max(n, wForms.length); i++) {
      if (i < n) { var w = wifiForm(i); w.wrap.hidden = false; w.label.hidden = n < 2; }
      else wForms[i].wrap.hidden = true;
    }
  }
  sameI.addEventListener('change', function () { layoutWifi(); refresh(); });
  function wifiOk(show) {
    var ok = true, n = wifiCount();
    for (var i = 0; i < n; i++) { var f = wifiForm(i).form; if (!f || !f.render(!!show)) ok = false; }
    return ok;
  }

  // Precio por placa con el descuento de la cantidad elegida (igual que el carrito: por unidad, redondeo hacia abajo)
  var logoPrice = logoCard && logoCard.querySelector('.tpxb-price');
  function unitHtml(price, p) {
    if (!p) return money(price);
    if (p === 20) return money(price) + '<small><em>−' + money(FIX2) + '</em> ' + t.onTotal + '</small>';
    return money(price - Math.floor(price * p / 100)) + '<small><s>' + money(price) + '</s> <em>' + tierTxt(p) + '</em></small>';
  }

  // Resumen
  var sum = document.getElementById('tpxb-sum'), go = document.getElementById('tpxb-go'), err = document.getElementById('tpxb-err');
  var note = document.getElementById('tpxb-note'), bar = document.getElementById('tpxb-bar');
  function total() { return qty.google + qty.instagram + qty.wifi; }
  var busy = false, rendering = false;
  function refresh() {
    if (rendering) return; rendering = true;
    var n = total(), all = n + inCart, p = pct(all);
    ladder.querySelectorAll('.tpxb-step').forEach(function (s) {
      var k = +s.getAttribute('data-n');
      s.classList.toggle('on', all > 0 && (k === 5 ? all >= 5 : all === k));
    });
    var nxt = TIERS.slice().reverse().filter(function (x) { return x[0] > all; })[0];
    note.textContent = (all === 0 ? t.start : nxt ? t.next(nxt[0] - all, saveTxt(nxt[1])) : t.max) + (inCart ? ' ' + t.inCart(inCart) : '');
    ['google', 'instagram', 'wifi'].forEach(function (k) {
      var o = outs[k]; if (!o) return;
      o.out.textContent = qty[k];
      o.minus.disabled = qty[k] <= 0;
      o.plus.disabled = qty[k] >= MAXQ;
      o.card.classList.toggle('on', qty[k] > 0);
      o.need.hidden = !qty[k];
      o.price.innerHTML = unitHtml(P[k].price, p);
    });
    if (logoPrice && +logoPrice.getAttribute('data-price')) logoPrice.innerHTML = unitHtml(+logoPrice.getAttribute('data-price'), p);
    var full = qty.google * P.google.price + qty.instagram * P.instagram.price + qty.wifi * P.wifi.price;
    // Igual que Shopify: el descuento se reparte por unidad y se redondea hacia abajo al céntimo
    var off = p === 20 ? Math.min(FIX2, full) : ['google', 'instagram', 'wifi'].reduce(function (a, k) { return a + qty[k] * Math.floor(P[k].price * p / 100); }, 0);
    var net = full - off;
    sum.innerHTML = '';
    if (!n) sum.appendChild(el('b', null, t.none));
    else {
      var b = el('b'); b.textContent = t.plates(n) + ' · ' + money(net); sum.appendChild(b);
      if (p) {
        var s = el('s'); s.textContent = money(full); sum.appendChild(s);
        var sm = el('small'); sm.textContent = inCart && pct(n) < p ? t.withCart(inCart, tierTxt(p)) : t.saving(money(full - net), p === 20 ? '' : tierTxt(p));
        sum.appendChild(sm);
      }
    }
    bar.hidden = !n && !busy;
    go.disabled = !n || busy;
    go.textContent = busy ? t.adding : n ? t.go : t.pick;
    setup.hidden = !n;
    pLink.hidden = !(qty.google || qty.instagram);
    lmulti.hidden = true; // el recuadro ya pregunta si son para el mismo negocio y deja elegir placa a placa
    pWifi.hidden = !qty.wifi;
    var wb = document.getElementById('tpxb-wb');
    if (wb && qty.wifi) { var ok = wifiOk(false); wb.textContent = ok ? t.linkDone : t.wifiReq; wb.className = 'tpxb-badge ' + (ok ? 'ok' : 'req'); }
    rendering = false;
  }
  function set(k, v) {
    qty[k] = Math.max(0, Math.min(MAXQ, v));
    err.hidden = true;
    loadFrame();
    layoutWifi();
    refresh();
  }

  go.addEventListener('click', function () {
    if (busy || !total()) return;
    err.hidden = true;
    if (qty.wifi && !wifiOk(true)) {
      err.textContent = t.wifiFix; err.hidden = false;
      for (var i = 0; i < wifiCount(); i++) {
        var w = wifiForm(i);
        if (!w.form.render(false)) {
          w.root.scrollIntoView({ behavior: 'smooth', block: 'center' });
          w.root.classList.add('tpxw-bad');
          (function (r) { setTimeout(function () { r.classList.remove('tpxw-bad'); }, 2000); })(w.root);
          w.form.render(true);
          break;
        }
      }
      return;
    }
    var items = [];
    var lp = linkCode ? { _taptics_vinculo: linkCode } : undefined;
    if (qty.google) items.push({ id: P.google.variant, quantity: qty.google, properties: lp });
    if (qty.instagram) items.push({ id: P.instagram.variant, quantity: qty.instagram, properties: lp });
    if (qty.wifi) {
      var n = wifiCount();
      for (var j = 0; j < n; j++) items.push({ id: P.wifi.variant, quantity: n === 1 ? qty.wifi : 1, properties: wifiForm(j).form.props() });
    }
    busy = true; refresh();
    var attrs = linkCode ? fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { taptics_vinculo: linkCode } }) }) : Promise.resolve();
    attrs.then(function () {
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) });
    }).then(function (r) {
      if (!r.ok) throw new Error('add');
      window.location.href = (D.root || '') + '/cart';
    }).catch(function () {
      busy = false; err.textContent = t.fail; err.hidden = false; refresh();
    });
  });

  // Placas que ya hay en el carrito (cuentan para el descuento) y código de vinculación guardado
  fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
    inCart = 0;
    (c.items || []).forEach(function (it) { if (eligible[it.variant_id]) inCart += it.quantity; });
    linkCode = (c.attributes && c.attributes.taptics_vinculo) || '';
    refresh();
  }).catch(function () {});

  // Preselección desde la URL: ?google=2&wifi=1
  try {
    var sp = new URLSearchParams(location.search);
    ['google', 'instagram', 'wifi'].forEach(function (k) { var v = parseInt(sp.get(k), 10); if (v > 0) qty[k] = Math.min(MAXQ, v); });
  } catch (e) {}
  function start() { loadFrame(); layoutWifi(); refresh(); }
  if (window.TapticsWifiForm) start(); else window.addEventListener('load', start);
})();
